import { render, staticRenderFns } from "./layout-no-login.vue?vue&type=template&id=999899f2"
import script from "./layout-no-login.vue?vue&type=script&lang=ts"
export * from "./layout-no-login.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports